<template lang="pug">
el-card(v-show="shouldShow", v-loading.body="loading")
  .cf(slot="header")
    h2 Събитие
  el-form(label-position="top", ref="form", :model="record", :rules="rules")

    el-row
      el-col(:sm="20")
        el-form-item(prop="name", label="Име")
          el-input(v-model="record.name")
      el-col(:sm="4")
        el-form-item(prop="startsAt", label="Дата")
          el-date-picker(:value="record.startsAt", @input="record.startsAt = modelDate($event)", type="date", placeholder="Избери дата")

    el-row
      el-col(:sm="4", :offset="16")
        el-form-item(prop="discount", label="Отстъпка")
          el-input(v-model.number="record.discount", type="number")
            template(slot="append") %
      el-col(:sm="4")
        el-form-item(prop="price", label="Цена")
          el-input(v-model.number="record.price", type="number")
            template(slot="append") лв.

    .form-actions.cf
      el-button.fl(type="text", icon="el-icon-arrow-left", @click="$router.push(url)") Назад към списъка
      el-button.fr(type="primary", @click="onSubmit") {{ isNew ? 'Създай' : 'Запази' }}
      el-button.fr(v-if="record.id", type="danger", @click="onDelete") Изтрий

  subject-history(v-if="!isNew", :filters="{type: 1040, EventId: record.id}", :show-contragent-name="true")
  //- payment-history(v-if="!isNew", :filters="{subject: 1040, EventId: record.id}")
</template>

<script>
import formMixin from '../mixins/formMixin.js'
import SubjectHistory from './SubjectHistory.vue'
import PaymentHistory from './PaymentHistory.vue'

export default {
  name: 'EventForm',
  mixins: [formMixin],
  props: {},
  data () {
    return {
      apiUrl: '/events',
      url: '/events',
      loading: true,
      record: {
        id: null,
        name: '',
        startsAt: '',
        discount: 0,
        price: 0,
      },
      rules: {
        name: {required: true, message: 'Полето е задължително'},
        startsAt: {required: true, message: 'Полето е задължително'},
        discount: {required: true, type: 'integer', min: 0, max: 100, message: 'Число от 0 до 100'},
        price: {required: true, type: 'number', min: 0, message: 'Невалидна цена'},
      },
      added: null
    }
  },
  methods: {
  },
  components: {
    SubjectHistory,
    PaymentHistory
  }
}
</script>